import React, { useEffect } from "react";
import { Box } from "@material-ui/core";
import TabContext from "@material-ui/lab/TabContext";
import TabPanel from "@material-ui/lab/TabPanel";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getPatientByIdRequest,
  getCasesRequest,
  getClosedCasesRequest,
  getOpenCasesRequest,
} from "../../PatientApiActions";
import { useStyles } from "./styles";
import { getUserInfo } from "../../../../utilities/storage";

import PatientHeader from "./components/PatientHeaders";
import CaseTabs from "./components/CaseTabs";
import HealthInformationTabs from "./components/HealthInformationTabs";

/**
 * function to render patient profile
 * @param history: history from router
 * @returns {JSX.Element}
 * @constructor
 */
const PatientProfile = ({
  history,
  selectedDept,
  getAthleteById,
  patient,
  getCases,
  cases,
  getOpenCases,
  openCases,
  getClosedCases,
  closedCases,
}) => {
  const user = getUserInfo();
  const role = user?.Roles?.[0]?.name;
  const params = useParams();
  const classes = useStyles();
  const [value, setValue] = React.useState("1");
  const [valueHealthHistory, setValueHealthHistory] = React.useState("1");

  useEffect(() => {
    getAthleteById(params.id).then(() => {});
  }, [getAthleteById, params.id]);

  useEffect(() => {
    getCases(selectedDept?.team_id, params.id).then(() => {});
    getOpenCases(selectedDept?.team_id, params.id).then(() => {});
    getClosedCases(selectedDept?.team_id, params.id).then(() => {});
  }, [
    getCases,
    getOpenCases,
    getClosedCases,
    selectedDept?.team_id,
    params.id,
  ]);

  /**
   * function to handle tab change
   * @param e
   * @param newValue
   */
  const handleChange = (e, newValue) => {
    setValue(newValue);
  };

  const handleChangeHealthHistory = (e, newValue) => {
    setValueHealthHistory(newValue);
  };

  /**
   * function to handle go back
   */
  const onBack = () => {
    history.goBack();
  };

  return (
    <Box style={{ paddingBottom: "3rem" }}>
      <PatientHeader patient={patient} onBack={onBack} />

      {patient && (
        <TabContext value={value}>
          <CaseTabs
            value={value}
            handleChange={handleChange}
            openCases={openCases}
            closedCases={closedCases}
            cases={cases}
            selectedDept={selectedDept}
            role={role}
            history={history}
          />

          <TabPanel value="4" className={classes.tabPanel}>
            <HealthInformationTabs
              valueHealthHistory={valueHealthHistory}
              handleChangeHealthHistory={handleChangeHealthHistory}
              patient={patient}
            />
          </TabPanel>
        </TabContext>
      )}
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    selectedDept: state.ayucareUsers.selectedDept,
    patient: state.athletes.athlete,
    cases: state.cases.cases,
    openCases: state.cases.openCases,
    closedCases: state.cases.closedCases,
    patientSymptom: state.patientSymptom,
    patientQuestionAnswer: state.patientQuestionAnswer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAthleteById: (id) => {
      return dispatch(getPatientByIdRequest(id)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getCases: (teamId, patientId) => {
      return dispatch(getCasesRequest(teamId, patientId)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getOpenCases: (teamId, patientId) => {
      return dispatch(getOpenCasesRequest(teamId, patientId)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },

    getClosedCases: (teamId, patientId) => {
      return dispatch(getClosedCasesRequest(teamId, patientId)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PatientProfile);
